module.exports = __webpack_public_path__ + "static/media/test_basic_linking.fd49ceae.csv";